import React, { useState, useEffect, useRef } from "react";
import { Layout } from "antd";
import Sidebar from "../components/Sidebar/Sidebar";
import Navbar from "../components/Header/Navbar";
import { sellerRoutes } from "../components/Sidebar/menuItems";
import { useLocation } from "react-router-dom";
import SellerBanner from "../components/Header/SellerBanner";
const { Content } = Layout;

const MainLayout = (props) => {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 768);
  const [collapsed, setCollapsed] = useState(() => window.innerWidth <= 768);
  const wasMobileRef = useRef(isMobile);
  const { pathname } = useLocation();
  let url_parts = pathname.split("/");
  let new_url = url_parts.slice(0, url_parts.length - 1).join("/");

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      // Only auto-collapse when actually crossing into mobile width — mobile
      // browsers fire `resize` on address-bar show/hide while scrolling,
      // which would otherwise force-close an open drawer mid-scroll.
      if (mobile && !wasMobileRef.current) setCollapsed(true);
      wasMobileRef.current = mobile;
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Layout style={{ background: "#fff" }}>
      {/* Header */}
      <Navbar collapsed={collapsed} setCollapsed={setCollapsed} />
      {sellerRoutes.includes(new_url) && <SellerBanner />}
      <Layout style={{ background: "#fff" }}>
        {/* Sidebar */}
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} isMobile={isMobile} />

        {/* Mobile backdrop overlay */}
        {isMobile && !collapsed && (
          <div
            onClick={() => setCollapsed(true)}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: "rgba(0, 0, 0, 0.45)",
              zIndex: 999,
            }}
          />
        )}

        {/* Content */}
        <Layout>
          <Content
            style={{
              background: "#fff",
              margin: 0,
              minHeight: 280,
            }}
          >
            {props.children}
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
